<template>
  <BLayoutExpansionTableAsync
    :value="list"
    v-bind="$attrs"
    :loading="isLoading"
    :readonly="readonly"
    :pagination="pagination"
    title="Участники"
    type-table="collector-participants"
    name="participants"
    return-object
    @change:pagination="onChangePagination"
    @action:download:variants="({ sha1_sum: sha1Sum }) => onDownload(sha1Sum)"
    @action:download="({ criteria_sha1_sum: criteriaSha1Sum }) => onDownload(criteriaSha1Sum)"
  >
    <template #top>
      <BListFilter
        v-model="searchForm"
        label="Поиск по имени"
        :skeleton="isLoading"
        dense
        @change="onChangeDebounced"
      />
    </template>
  </BLayoutExpansionTableAsync>
</template>

<script>
import BLayoutExpansionTableAsync from '@/components/layouts/BLayoutExpansionTableAsync.vue'
import { downloadLinkByGet } from '@/helpers/downloadBlob'

import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { KimUsersApi } from '@/api/resources'
import BListFilter from '@/components/forms/BListFilter.vue'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  count: 0,
}

export default {
  name: 'BasePublicationsParticipantsExpansionTable',
  components: { BLayoutExpansionTableAsync, BListFilter },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    searchForm: {
      search: null,
    },
    pagination: { ...DEFAULT_PARAMS },
  }),
  computed: {
    readonly() {
      return !this.$access(Permissions.edit)
    },
  },
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    async onGetData(params) {
      const api = new KimUsersApi()
      try {
        const result = await api.getAll({
          ...this.pagination,
          ...this.searchForm,
          ...params,
          publication_id: this.publication.publication_id,
        })
        this.list = result.data
        this.pagination.count = result.meta.count
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    onChangeDebounced() {
      this.onGetData()
    },
    onDownload(sha1Sum) {
      if (!sha1Sum) return
      try {
        const path = `${process.env.VUE_APP_COLLECTOR_API_URL}/api/v1/files/${sha1Sum}/download`
        downloadLinkByGet(
          path,
          false,
          { isNewTab: false },
          { headers: { 'X-Access-Token': process.env.VUE_APP_COLLECTOR_API_TOKEN } },
        )
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
